module.exports = __webpack_public_path__ + "static/media/banner-latest-residence.9ab2b6b0.jpg";